





























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import bookingDefault from '@/instance-defaults/bookingDefault';
import HourPicker from '@/components/Views/Booking Flow/HourPicker.vue';
import {BOOKING_HOURS, BOOKING_STATUS, CALENDAR_FORMAT, getStoreSettings, multiNil, nil} from '@/common';
import {DateTime, IANAZone} from 'luxon';
import {Mixins} from 'vue-property-decorator';
import LocationMixin from '@/mixins/LocationMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import TimePicker from "@/components/Views/UI/TimePicker.vue";
import BookingDateMixin from '@/mixins/BookingDateMixin.vue';
@Component({
    components: {
        TimePicker,
        HourPicker,
    },
})
export default class ChangeBookingDialog extends Mixins(LocationMixin, GlobalAlertMixin, BookingDateMixin) {
    public open = false;
    @Prop({default: () => bookingDefault})
    public booking!: any;
    @Watch('formattedAddress')
    private onLocationChanged(value: string, oldValue: string) {
        this.selectedAddress = value;
    }
    public onChangeNotifyVendor = false;
    public onChangeNotifyPurchaser = false;
    public selectedTime: string = "03:00";
    public selectedDate = DateTime.local().toFormat(CALENDAR_FORMAT);
    public validBookingHours = [];
    public selectedAddress = '';
    @Watch('selectedAddress')
    public onSelectedAddressChanged(value: string, oldValue: string) {
        /*this.formattedAddress = '';
        this.longitude = null;
        this.latitude = null;*/
    }
    private maximumBookTime = DateTime.local().plus({years: 1});
    public today = DateTime.local();
    private settings: any = null;
    @Watch('booking')
    public onBookingChanged(value: any, oldValue: any) {
        this.refreshBooking();
    }
    public mounted() {
        this.refreshBooking();
    }
    public created() {
        this.refreshBooking();
    }
    public allowedDates(value: string) {
        const ast = DateTime.fromFormat(value, CALENDAR_FORMAT);
        let useToday = false;
        if (!nil(this.settings)) {
            const earliest = DateTime.local().plus({hours: this.settings.maxBookTime});
            useToday = earliest.hour < this.validBookingHourMax;
        }
        const todaySimple = DateTime.fromFormat(this.today.toFormat(CALENDAR_FORMAT), CALENDAR_FORMAT);
        return ast >= todaySimple.plus({days: useToday ? 0 : 1}) && ast <= this.maximumBookTime;
    }
    public get validBookingHourMin(){
        return this.validBookingHours[0];
    }
    public get validBookingHourMax(){
        return this.validBookingHours[this.validBookingHours.length-1];
    }
    public async refreshBooking() {
        if (nil(this.booking)) { return; }
        console.log('refreshing booking');
        this.settings = await getStoreSettings(this.$FeathersVuex.Setting);
        this.validBookingHours = BOOKING_HOURS.getHours(await getStoreSettings(this.$FeathersVuex.Settings))
        this.maximumBookTime = DateTime.local().plus({days: this.settings.maxBookAdvanceDays});
        this.selectedDate = this.zonedBookingDate.toFormat(CALENDAR_FORMAT);
        this.selectedAddress = this.booking.address;
        this.selectedTime = this.zonedBookingDate.toFormat('HH:mm');
        this.formattedAddress = this.booking.address;
        this.longitude = this.booking.location.coordinates[0];
        this.latitude = this.booking.location.coordinates[1];
    }
    public performUpdate() {
        const time = DateTime.fromFormat(this.selectedTime, "HH:mm");
        //this.booking.date = this.zonedBookingDate.set({hour:time.hour, minute:time.minute}).toUTC().toISO();
        const date = DateTime.fromFormat(this.selectedDate, CALENDAR_FORMAT);
        this.booking.date = DateTime.fromObject({
            hour:time.hour,
            minute:time.minute,
            day:date.day,
            month: date.month,
            year: date.year,
            zone:IANAZone.create(this.booking.timezone),
        }).toUTC().toISO();
        this.booking.address = this.formattedAddress;
        this.booking.location = {
            type: 'Point',
            coordinates: [this.longitude, this.latitude],
        };
        this.booking.onChangeNotifyVendor = this.onChangeNotifyVendor;
        this.booking.onChangeNotifyPurchaser = this.onChangeNotifyPurchaser;
        try {
            this.booking.save();
            this.$emit('onBookingUpdated', this.booking);
            this.open = false;
        } catch (e) {
            this.showAlert(e.message, 'error');
        }
    }
    public get bookingCancelled() {
        if (multiNil(this, 'booking.status')) { return false; }
        return this.booking.status === BOOKING_STATUS.CANCELLED;
    }
    public get bookingFulfilled() {
        if (multiNil(this, 'booking.status')) { return false; }
        return this.booking.status === BOOKING_STATUS.FULFILLED;
    }
    public get changeOrderText() {
        if (this.bookingCancelled) {
            return 'Can\'t Change Cancelled Order';
        } else if (this.bookingFulfilled) {
            return 'Can\'t Change Fulfilled Order';
        }
        return 'Change Date, Time Or Location';
    }
    public get updateDisabled() {
        return nil(this.formattedAddress, true) || nil(this.longitude, true) || nil(this.latitude, true);
    }
    public get smallMode(){
        return this.isXS(null);
    }
}
